import { render, staticRenderFns } from "./SasvDuplicate.vue?vue&type=template&id=7a853168"
import script from "./SasvDuplicate.vue?vue&type=script&lang=js"
export * from "./SasvDuplicate.vue?vue&type=script&lang=js"
import style0 from "./SasvDuplicate.vue?vue&type=style&index=0&id=7a853168&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports